"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Widget = void 0;
var _presentationHttp = require("@ori/presentation-http");
var _api = require("../../api");
var _useGetOlapicConfig = require("../../api/useGetOlapicConfig");
var _components = require("../../components");
var _contexts = require("../../contexts");
var _olapicDataContext = require("../../contexts/olapicDataContext/olapicDataContext");
var _logger = require("../../logger");
var _models = require("../../models");
var _components2 = require("./components");
var _jsxRuntime = require("react/jsx-runtime");
const childLogger = _logger.mainLogger.createChild('Widget');
const Widget = () => {
  const {
    categoryId,
    type,
    productCode
  } = (0, _contexts.useConfiguration)();
  const {
    data: {
      apiKey,
      hideCaption,
      olapicType
    },
    isEmpty
  } = (0, _useGetOlapicConfig.useGetOlapicConfig)({
    categoryId,
    type
  });
  const {
    media,
    loaded,
    shareItemId,
    isError
  } = (0, _api.useGetOlapicData)({
    apiKey,
    type: olapicType
  });
  const isGallery = olapicType === _models.OlapicTypeEnum.Gallery;
  const loadingComponent = isGallery ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.GallerySkeleton, {}) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.SliderSkeleton, {});
  if (isEmpty) {
    childLogger.debug('Error: Configuration is empty.');
    return null;
  }
  if (apiKey === '') {
    childLogger.debug('Error: There is no OlapicWidget API key.');
    return null;
  }
  if (olapicType === _models.OlapicTypeEnum.Category && !categoryId) {
    childLogger.debug('Error: Type is category and category id is not provided.');
    return null;
  }
  if (olapicType === _models.OlapicTypeEnum.ProductDetails && !productCode) {
    childLogger.debug('Error: Type is product and product code is not provided.');
    return null;
  }
  if (isError) {
    childLogger.debug('Error: No media items found.');
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_presentationHttp.UserSegmentationDataProvider, {
    children: loaded ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_olapicDataContext.OlapicDataProvider, {
      mediaItems: media?.mediaItems ?? [],
      loadMoreUrl: media?.loadMoreUrl,
      apiKey: apiKey ?? '',
      hideCaption: hideCaption,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_components2.WidgetContent, {
        shareItemId: shareItemId,
        isGallery: isGallery
      })
    }) : loadingComponent
  });
};
exports.Widget = Widget;
